export default __webpack_public_path__ + "static/media/b12.8d49112e.jpg";